import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { post } from '../apiClient'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export enum RightOfAccessStarts {
  TODAY = 'today',
  NEXT_MONTH = 'next_month',
}

export interface CreateRightOfAccessRequest {
  sharedAreaId: number
  starts: RightOfAccessStarts
}

export const useAPICreateRightOfAccess = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: CreateRightOfAccessRequest): Promise<void> => {
      await post(
        `/contracts/${contractId}/rights-of-access`,
        request as unknown as Record<string, unknown>,
        z.void()
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractId}/shared-areas`],
      })
      await queryClient.invalidateQueries({
        queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractId}/rights-of-access`],
      })
      await queryClient.invalidateQueries({
        queryKey: ['extra-service-reservations', contractId],
      })
    },
  })
}
